module.exports = __webpack_public_path__ + "static/media/core-beliefs.f4b3cb07.jpeg";